import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  Bus,
  NotificationManager,
  SiteConfigManager,
  StorageManager,
  useApplicationState,
  useUserMessages,
} from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES } from '@atlas/routing';

import { POPUP_MESSAGES_STORAGE_KEY } from 'common/constants';
import history from 'components/Layout/history';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { messages: messagesPath } = clientProfileRoutes;

export const useShowMessagesPopup = () => {
  const { authenticated } = useApplicationState();
  const { pathname } = useLocation();
  const { clearUserMessages, unreadMessagesCount } = useUserMessages();

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  const isPopupShowed = StorageManager.getItem(POPUP_MESSAGES_STORAGE_KEY);

  const clientProfilePage = SiteConfigManager.getConfig('config.pages').find(
    page => page.type === CLIENT_PROFILE,
  );
  const messagesTab = clientProfilePage?.options?.tabs.find(tab => tab.type === 'messages');

  const onConfirmHandler = useCallback(
    () => history.push(`${clientProfilePath}/${messagesPath}`),
    [clientProfilePath],
  );

  const logoutCallback = useCallback(() => {
    StorageManager.removeItem(POPUP_MESSAGES_STORAGE_KEY);
    clearUserMessages();
  }, [clearUserMessages]);

  useEffect(() => {
    Bus.on(Bus.events.auth.logout, logoutCallback);
    return () => Bus.off(Bus.events.auth.logout, logoutCallback);
  }, [logoutCallback]);

  useEffect(() => {
    if (
      !authenticated ||
      !unreadMessagesCount ||
      pathname.includes('/game') ||
      pathname.includes('/virtual-game') ||
      isPopupShowed ||
      !messagesTab?.isActive
    ) {
      return;
    }

    NotificationManager.display({
      data: {
        onConfirm: onConfirmHandler,
      },
      type: 'messages',
    });

    StorageManager.setItem(POPUP_MESSAGES_STORAGE_KEY, 'true');
  }, [
    authenticated,
    isPopupShowed,
    messagesTab?.isActive,
    onConfirmHandler,
    pathname,
    unreadMessagesCount,
  ]);
};
